module.exports = __webpack_public_path__ + "img/404.d3417927.jpg";